<template>
  <div class="col-sm-4">
    <div class="product-image-wrapper">
      <div class="single-product-category">
        <div class="productinfo text-center">
          <img class="img-responsive" :src="'/static/images/product/' + productGroup.image" :alt="productGroup.description" @error="replaceNonFoundImage($event)">
          <h2>{{productGroup.description}}</h2>
          <router-link :to="'/shop/' + productGroup.slug" class="btn btn-default add-to-cart">View <span class="basket">{{productGroup.description}}</span></router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'product-group-item',
  props: ['productGroup'],
  methods: {
    /* eslint no-param-reassign: "error" */
    replaceNonFoundImage(event) {
      event.target.src = '/static/images/product/notfound.jpg';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/products/ProductGroupItem.vue